import { useCatalogueStore } from '@/store/catalogue-store';
import { Package2 } from 'lucide-react';

interface ProductImageProps {
  productCode: string;
  className?: string;
  alt?: string;
}

export function ProductImage({ productCode, className = '', alt }: ProductImageProps) {
  const getImageForProduct = useCatalogueStore((state) => state.getImageForProduct);
  const imageData = getImageForProduct(productCode);

  if (!imageData) {
    return (
      <div
        data-testid={`product-image-${productCode}`}
        className={`flex items-center justify-center bg-gray-100 ${className}`}
      >
        <Package2 className="h-16 w-16 text-gray-300" />
      </div>
    );
  }

  return (
    <img
      data-testid={`product-image-${productCode}`}
      src={imageData.dataUri}
      alt={alt || `Product ${productCode}`}
      className={className}
    />
  );
}
